module.exports = __webpack_public_path__ + "static/img/disappear.95cdb019.svg";